import { ref } from "vue";
import { useForm } from "@erp/shared/composables/useForm";
import { cloneDeep } from "es-toolkit";
import { useState } from "@erp/shared/composables/useState";
export var SOMETHING_WRONG;
(function (SOMETHING_WRONG) {
    SOMETHING_WRONG["\uC774\uC0C1\uC5C6\uC74C"] = "\uC774\uC0C1 \uC5C6\uC74C";
    SOMETHING_WRONG["\uC774\uC0C1\uC788\uC74C"] = "\uC774\uC0C1 \uC788\uC74C";
})(SOMETHING_WRONG || (SOMETHING_WRONG = {}));
export const useInboundRegister = (inboundInfoInputs) => {
    const inboundInfoFormValid = ref(false);
    const somethingWrong = ref(SOMETHING_WRONG.이상없음);
    const [somethingWrongReason, setSomethingWrongReason] = useState("");
    const inboundItems = ref([]);
    const { inputs: inboundInputs, setInputs: setInboundInputs, formData, resetForm, updateInputs, } = useForm(cloneDeep(inboundInfoInputs));
    const toggleSomethingWrong = () => {
        somethingWrong.value =
            somethingWrong.value === SOMETHING_WRONG.이상없음
                ? SOMETHING_WRONG.이상있음
                : SOMETHING_WRONG.이상없음;
    };
    const setSpotAtOnce = (selectedSpot) => {
        inboundItems.value.forEach((item) => {
            item.spot = selectedSpot;
        });
    };
    const resetTable = () => {
        inboundItems.value = [];
    };
    const setInboundInfoFormValid = (value) => {
        inboundInfoFormValid.value = value;
    };
    return {
        somethingWrong,
        somethingWrongReason,
        inboundItems,
        inboundInputs,
        formData,
        inboundInfoFormValid,
        setInboundInputs,
        setSpotAtOnce,
        toggleSomethingWrong,
        setSomethingWrongReason,
        resetForm,
        resetTable,
        setInboundInfoFormValid,
        updateInputs,
    };
};
